import WebAPI from './api-calls';

const webApi = new WebAPI();

export async function fetchEnquiries({ page, pageSize, status, sort, from, to } = {}) {
  const endpoint = '/api/multiutility/enquiries';

  const payload = {};
  if (page) payload.page = page;
  if (pageSize) payload.pageSize = pageSize;
  if (status) payload.status = status;
  if (sort) payload.sort = sort;
  if (from) payload.from = from;
  if (to) payload.to = to;

  const response = await webApi.getFromWebApiWithAccessTokenAsync(
    endpoint,
    Object.keys(payload).length ? payload : undefined
  );

  return response.data;
}

export async function fetchEnquiryDetail(reference) {
  const endpoint = `/api/multiutility/enquiries/${encodeURIComponent(reference)}`;

  const response = await webApi.getFromWebApiWithAccessTokenAsync(endpoint);

  return response.data;
}
